var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2337 16.8517L8.66637 10.6983H15.7907L12.2337 16.8517ZM16.2896 9.99951L15.2896 8.99951L14.9447 8.64263H13.5389H10.7271H5.10366L12.2337 20.954L18.072 10.8622L16.2896 9.99951ZM2.72852 4.54492L3.91609 6.60063H12.2285H14.3066H15.2896V5.99951V5.49951V4.99951L14.6035 4.54492H12.2285H2.72852Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4775 6.22382L22.4786 6.22276C22.8782 5.8208 22.8782 5.17166 22.4786 4.76969L22.4775 4.76864L20.7316 3.02273C20.3285 2.61965 19.675 2.61965 19.2719 3.02273C18.8734 3.42124 18.869 4.06438 19.2581 4.46833H14.8502C13.988 4.46833 13.2891 5.16726 13.2891 6.02943V7.09052C13.2891 7.65968 13.7505 8.12107 14.3196 8.12107C14.8888 8.12107 15.3502 7.65968 15.3502 7.09052V6.52943H19.2618C18.8724 6.93217 18.8765 7.57432 19.2742 7.97197C19.676 8.37381 20.3275 8.37381 20.7294 7.97197L22.4775 6.22382Z",
    fill: "black",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5899 9.76837L13.5888 9.76942C13.1892 10.1714 13.1892 10.8205 13.5888 11.2225L13.5899 11.2235L15.3358 12.9695C15.7388 13.3725 16.3924 13.3725 16.7954 12.9695C17.1939 12.5709 17.1984 11.9278 16.8092 11.5239L21.2172 11.5239C22.0794 11.5239 22.7783 10.8249 22.7783 9.96276L22.7783 8.90166C22.7783 8.33251 22.3169 7.87112 21.7478 7.87112C21.1786 7.87112 20.7172 8.33251 20.7172 8.90166L20.7172 9.46276L16.8056 9.46276C17.195 9.06002 17.1908 8.41787 16.7932 8.02022C16.3914 7.61838 15.7399 7.61838 15.338 8.02022L13.5899 9.76837Z",
    fill: "black",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.92b2d1f5.svg";
export { ForwardRef as ReactComponent };